export default "__VITE_ASSET__CyRgDyoN__"